import type { MatchCounter, MatchRuleSet } from '@/core/schemas';

import { applyTurn, createGame } from './game';
import type { GameState } from './types';

/**
 * Reconstructs the live game state from a stored counter by folding its turn
 * log through the engine.
 *
 * This is why the turn log stores raw throws: replaying them reproduces busts,
 * leg wins and the current thrower deterministically, so no derived state ever
 * has to be trusted from storage.
 */
export function replayCounter(counter: MatchCounter, rules: MatchRuleSet): GameState {
  let state = createGame({
    config: { startScore: counter.startScore, doubleOut: counter.doubleOut },
    rules,
    entryMode: counter.entryMode,
    startingSide: counter.startingSide,
  });

  for (const turn of counter.turns) {
    state = applyTurn(state, {
      points: turn.points,
      finishedOnDouble: turn.finishedOnDouble,
      ...(turn.darts !== undefined ? { darts: turn.darts } : {}),
    });
  }

  return state;
}
